import React from "react";
import { ComponentWithAs, Icon, IconProps } from "@chakra-ui/react";

const IconComp: ComponentWithAs<"svg", IconProps> = ({
  children,
  ...props
}) => {
  return (
    <Icon {...props}>
      <path
        fill="#B0BEC5"
        d="M64,0C28.656,0,0,28.656,0,64s28.656,64,64,64s64-28.656,64-64S99.344,0,64,0z M64,120
			C33.125,120,8,94.875,8,64S33.125,8,64,8s56,25.125,56,56S94.875,120,64,120z"
      />

      <path
        fill="#8BC34A"
        d="M32.891,69.656l16.969,16.969c3.117,3.125,8.188,3.125,11.313,0l33.938-33.938
	c3.125-3.125,3.125-8.195,0-11.313c-3.117-3.125-8.188-3.125-11.313,0L55.516,69.656L44.203,58.344
	c-3.125-3.125-8.195-3.125-11.313,0C29.766,61.469,29.766,66.539,32.891,69.656z"
      />
    </Icon>
  );
};
IconComp.defaultProps = {
  viewBox: "0 0 128 128",
  boxSize: "20px",
};

export default IconComp;
